import { useSyncExternalStore } from 'use-sync-external-store/shim';
import { DefaultTreatment, FeatureFlagProvider } from './featureFlagProvider/FeatureFlagProvider';

export type FeatureFlagConf = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

export class FeatureFlagController<Conf extends FeatureFlagConf> {
  private _provider: FeatureFlagProvider;

  constructor(featureFlagProvider: FeatureFlagProvider) {
    this._provider = featureFlagProvider;
  }

  getTreatment<K extends Extract<keyof Conf, string>>(featureName: K) {
    return this._provider.getTreatment(featureName) as Conf[K] | DefaultTreatment;
  }

  subscribe = (callback: (controller: FeatureFlagController<Conf>) => void) => {
    const cb = () => callback(this);
    const onAvailableUnsubscribe = this._provider.onAvailable(cb);
    const onUpdateUnsubscribe = this._provider.onUpdate(cb);

    return () => {
      onAvailableUnsubscribe();
      onUpdateUnsubscribe();
    };
  };

  onAvailable(callback: (controller: FeatureFlagController<Conf>) => void) {
    return this._provider.onAvailable(() => callback(this));
  }

  onReady(callback: (controller: FeatureFlagController<Conf>) => void) {
    return this._provider.onReady(() => callback(this));
  }

  onUpdate(callback: (controller: FeatureFlagController<Conf>) => void) {
    return this._provider.onUpdate(() => callback(this));
  }

  useTreatment<K extends Extract<keyof Conf, string>>(featureName: K) {
    const getSnapshot = () => this.getTreatment(featureName);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useSyncExternalStore(this.subscribe, getSnapshot);
  }
}
